import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37340f31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 mw-700px mx-auto mb-10 pe-0 ml-1" }
const _hoisted_2 = { class: "row text-start" }
const _hoisted_3 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "Name", -1))
const _hoisted_5 = { class: "fv-plugins-message-container text-start" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "row text-start" }
const _hoisted_8 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "Provider", -1))
const _hoisted_10 = { class: "fv-plugins-message-container text-start" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row text-start" }
const _hoisted_13 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "Email", -1))
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row text-start" }
const _hoisted_18 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "Password", -1))
const _hoisted_20 = { class: "fv-plugins-message-container text-start" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "my-2 required" }
const _hoisted_25 = { class: "fv-plugins-message-container text-start" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "my-2" }
const _hoisted_29 = { class: "fv-plugins-message-container text-start" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row text-start" }
const _hoisted_32 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "Host Name", -1))
const _hoisted_34 = { class: "fv-plugins-message-container text-start" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row text-start" }
const _hoisted_37 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "Port No", -1))
const _hoisted_39 = { class: "fv-plugins-message-container text-start" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row text-start" }
const _hoisted_42 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "URL", -1))
const _hoisted_44 = { class: "fv-plugins-message-container text-start" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "row text-start" }
const _hoisted_47 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "API Key", -1))
const _hoisted_49 = { class: "fv-plugins-message-container text-start" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "row text-start" }
const _hoisted_52 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 required" }, "API Secret", -1))
const _hoisted_54 = { class: "fv-plugins-message-container text-start" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row text-start" }
const _hoisted_57 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2" }, "SSL Enable", -1))
const _hoisted_59 = { class: "form-check form-check-solid" }
const _hoisted_60 = { class: "fv-plugins-message-container text-start" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row text-start" }
const _hoisted_63 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2" }, "Status", -1))
const _hoisted_65 = { class: "fv-plugins-message-container text-start" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "min-w-90px btn btn-outline btn-outline-primary btn-active-light-primary"
}, " Save ", -1))

import { Form, ErrorMessage, Field } from "vee-validate";
export interface propsComponent {
  modelValue: boolean;
  selectedItem?: IEmailConfig;
  showDialog: boolean;
}
import {
  computed,
  withDefaults,
  onMounted,
  ref,
  watch,
  nextTick,
} from "vue";
import * as yup from "yup";
import { EmailAPI } from "@/services/api/Email.service";


import { defineComponent } from "vue";
import VZModal from "@/components/content/VZModal.vue";
import { TranslationService } from "@/core/services/TranslationService";
import {
  IEmailConfig,
  IOtherEmailConfigModel,
  IVyzorEmailConfigModel,
} from "@/interfaces/iEmail";
import { getLookups } from "@/services/api/Lookup.service";
import { IOptionModel } from "@/interfaces/iPageModel";
import { useToast } from "vue-toastification";
import { hideModal } from "@/core/helpers/dom";
import moment from "moment-timezone";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
const __default__ = defineComponent({
  name: "CreateEditEmailConfig",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { type: Boolean, default: false },
    selectedItem: { default: undefined },
    showDialog: { type: Boolean, default: false }
  },
  emits: ["submit", "confirm-discard"],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: boolean, selectedItem: IEmailConfig, showDialog: boolean }

function t(key: string) {
  return TranslationService.translate(key);
}


const id = `vz_create_edit_email_config_modal`;
const typeURL =
  "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKEmailProvider";
const toast = useToast();
const addMessage = t("pages.email.emailConfigAddedMessage");
const editMessage = t("pages.email.emailConfigUpdatedMessage");
const emailProvider = ref("");
const url = ref("");
const password = ref("");
const startDate = ref<any>(undefined);
const endDate = ref<any>(undefined);
const apiKey = ref("");
const secret = ref("");
const email = ref("");
const portNo = ref("");
const hostName = ref("");
const name = ref("");
const enableSsl = ref(false);
const status = ref("Active");
const form = ref();
const typeOptions = ref<IOptionModel[]>([]);
const formTitle = computed(() => {
  return props.selectedItem?.webId
    ? t("pages.email.emailConfig.editEmail")
    : t("pages.email.emailConfig.addEmail");
});
const isVyzorEmail = computed(() => {
  return !(+emailProvider.value <= 100);
});

const displayDate = computed(() => {
  return process.env.VUE_APP_DATE_PICKER_FORMAT || "MM-dd-yyyy";
});

// url is only requirede when type is less than 100
const schema = yup.object({
  name: yup
    .string()
    .max(30, getMaxLengthErrorMessage(t("pages.email.name"), 30))
    .required(t("pages.email.name") + " " + t("common.isRequired"))
    .matches(/\S/, t("pages.email.name") + " " + t("common.isRequired")),
  emailProvider: yup
    .string()
    .required(t("pages.email.provider") + " " + t("common.isRequired")),
  password: yup
    .string()
    .max(30, getMaxLengthErrorMessage(t("pages.email.password"), 30))
    .required(t("pages.email.password") + " " + t("common.isRequired")),
  startDate: yup
    .date()
    .required(t("common.startDate") + " " + t("common.isRequired"))
    .nullable(),
  endDate: yup
    .date()
    .min(yup.ref("startDate"), t("validation.greaterEndDate"))
    .nullable(),
  url: yup.string().when("emailProvider", {
    is: (val) => val > 100,
    then: yup.string().required("URL is Required"),
  }),
  apiKey: yup.string().when("emailProvider", {
    is: (val) => val > 100,
    then: yup.string().required("Api Key is Required"),
  }),
  secret: yup.string().when("emailProvider", {
    is: (val) => val > 100,
    then: yup.string().required("Secret is Required"),
  }),
  email: yup.string().when("emailProvider", {
    is: (val) => val <= 100,
    then: yup
      .string()
      .required(t("pages.email.email") + " " + t("common.isRequired"))
      .test("is-email", "Invalid email", function (value) {
        const { createError, originalValue } = this;
        if (originalValue && originalValue.length > 0) {
          return (
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
            createError({ path: this.path, message: "Invalid email address" })
          );
        }
        return true;
      }),
  }),

  portNo: yup.string().when("emailProvider", {
    is: (val) => val <= 100,
    then: yup.string().required("Port No is Required"),
  }),
  hostName: yup.string().when("emailProvider", {
    is: (val) => val <= 100,
    then: yup.string().required("Host Name is Required"),
  }),
  enableSsl: yup.boolean(),
});
const statusOptions = [
  {
    label: t("common.active"),
    value: "Active",
  },
  {
    label: t("common.inactive"),
    value: "Inactive",
  },
];
const format = computed(() => {
  return FormatMethods;
});
const submit = async (values) => {
  try {
    //prepare data for api
    const reqData: IEmailConfig = {
      emailProvider: values.emailProvider,
      name: values.name,
      webId: values.webId,
      data: undefined,
      startDate: values.startDate,
      endDate: values.endDate,
    };

    const dateFormat = "YYYY-MM-DDTHH:mm:ssZ";
    const startMoment = moment(reqData.startDate).startOf("day");
    const formattedStartDate = startMoment.format(dateFormat);
    reqData.startDate = formattedStartDate;
    if (reqData.endDate) {
      const endMoment = moment(reqData.endDate).endOf("day");
      const formattedEndDate = endMoment.format(dateFormat);
      reqData.endDate = formattedEndDate;
    }
    let data = {} as IOtherEmailConfigModel | IVyzorEmailConfigModel;
    if (isVyzorEmail.value) {
      data = {
        url: values.url,
        apiKey: values.apiKey,
        secret: values.secret,
        password: values.password,
      } as IOtherEmailConfigModel;
    } else {
      data = {
        email: values.email,
        portNo: values.portNo,
        hostName: values.hostName,
        enableSsl: enableSsl.value ?? false,
        password: values.password,
      } as IVyzorEmailConfigModel;
    }
    await EmailAPI.getInstance().addEmailConfig(
      { ...reqData, data, webId: props.selectedItem?.webId },
      props.selectedItem?.webId ? true : false
    );
    const message = props.selectedItem?.webId ? editMessage : addMessage;
    toast.success(message);
    // emmit submit event
    emit("submit");
  } catch (err) {
    console.log(err);
  }
};

onMounted(async () => {
  try {
    const data = await getLookups(typeURL);
    typeOptions.value = data?.map((item) => {
      return {
        value: item.value,
        text: item.text,
      };
    });
  } catch (err) {
    console.log(err);
  }
  nextTick(() => {
    form.value.resetForm();
  });
});

// watch on model value
watch(
  () => props.modelValue,
  (val) => {
    if (!val) {
      name.value = "";
      emailProvider.value = "";
      nextTick(() => {
        form.value.resetForm();
      });
    }
    if (val) {
      nextTick(() => {
        // form.value.setValues(initialValues.value);
        form.value.resetForm();
        name.value = props.selectedItem?.name ?? "";
        emailProvider.value = props.selectedItem?.emailProvider
          ? `${props.selectedItem?.emailProvider}`
          : "";
        url.value = props.selectedItem?.data?.url ?? "";
        password.value = props.selectedItem?.data?.password ?? "";
        apiKey.value = props.selectedItem?.data?.apiKey ?? "";
        secret.value = props.selectedItem?.data?.secret ?? "";
        email.value = props.selectedItem?.data?.email ?? "";
        portNo.value = props.selectedItem?.data?.portNo ?? "";
        hostName.value = props.selectedItem?.data?.hostName ?? "";
        enableSsl.value = props.selectedItem?.data?.enableSsl ?? false;
        status.value =
          props.selectedItem?.status.charAt(0).toUpperCase() +
          props.selectedItem?.status.slice(1).toLowerCase();
        startDate.value = props.selectedItem?.startDate ?? null;
        endDate.value = props.selectedItem?.endDate ?? null;
      });
    }
  }
);
const minDate = computed(() => {
  return moment().format("YYYY-MM-DD");
});
const minEndDate = computed(() => {
  const today = moment().format("YYYY-MM-DD");
  const startDatee = moment(startDate.value).format("YYYY-MM-DD");
  if (today >= startDatee) {
    return today;
  } else {
    return startDatee;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_unref(Form), {
    onSubmit: submit,
    "validation-schema": _unref(schema),
    ref_key: "form",
    ref: form
  }, {
    default: _withCtx(() => [
      _createVNode(VZModal, {
        title: _unref(formTitle),
        id: id,
        showDialog: __props.showDialog,
        widthClass: 'width-700',
        heightClass: 'height-510',
        onModalClose: _cache[19] || (_cache[19] = 
        () => {
          _ctx.$emit('confirm-discard');
        }
      )
      }, {
        actions: _withCtx(() => [
          _createElementVNode("button", {
            type: "reset",
            class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
            onClick: _cache[18] || (_cache[18] = 
            () => {
              _ctx.$emit('confirm-discard');
            }
          )
          }, " Close "),
          _hoisted_67
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_unref(Field), {
                  type: "text",
                  name: "name",
                  autocomplete: "off",
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ErrorMessage), { name: "name" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_unref(Field), {
                  name: "emailProvider",
                  modelValue: emailProvider.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailProvider).value = $event)),
                  class: "form-select form-select-lg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "Please select type",
                      label: "text",
                      value: "value",
                      class: "w-100",
                      name: "emailProvider",
                      modelValue: emailProvider.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailProvider).value = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (option, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: option.text,
                            value: option.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(ErrorMessage), { name: "emailProvider" })
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_unref(Field), {
                  type: "text",
                  name: "email",
                  placeholder: "Email@example.com",
                  autocomplete: "off",
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(ErrorMessage), { name: "email" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, !_unref(isVyzorEmail)]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_unref(Field), {
                  type: "password",
                  name: "password",
                  autocomplete: "off",
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((password).value = $event)),
                  class: "form-control"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_el_input, _mergeProps(field, {
                      modelValue: password.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
                      "show-password": ""
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(ErrorMessage), { name: "password" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(t("common.startDate")), 1),
                _createVNode(_unref(Field), {
                  name: "startDate",
                  autocomplete: "off",
                  modelValue: startDate.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((startDate).value = $event)),
                  class: "form-control"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(Datepicker), _mergeProps({
                      placeholder: t('common.selectDate'),
                      modelValue: startDate.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((startDate).value = $event)),
                      enableTimePicker: false,
                      format: _unref(displayDate),
                      utc: "",
                      "model-type": "yyyy-MM-dd",
                      autoApply: true
                    }, field, {
                      "min-date": _unref(minDate),
                      teleport: "body"
                    }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_unref(ErrorMessage), { name: "startDate" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(t("common.endDate")), 1),
                _createVNode(_unref(Field), {
                  name: "endDate",
                  autocomplete: "off",
                  modelValue: endDate.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((endDate).value = $event)),
                  class: "form-control"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(Datepicker), _mergeProps({
                      placeholder: t('common.selectDate'),
                      modelValue: endDate.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((endDate).value = $event)),
                      enableTimePicker: false,
                      format: _unref(displayDate),
                      utc: "",
                      "model-type": "yyyy-MM-dd",
                      autoApply: true
                    }, field, {
                      "min-date": _unref(minEndDate),
                      teleport: "body"
                    }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_unref(ErrorMessage), { name: "endDate" })
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_unref(Field), {
                  type: "text",
                  name: "hostName",
                  autocomplete: "off",
                  modelValue: hostName.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((hostName).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_unref(ErrorMessage), { name: "hostName" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, !_unref(isVyzorEmail)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_unref(Field), {
                  type: "number",
                  name: "portNo",
                  autocomplete: "off",
                  modelValue: portNo.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((portNo).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_unref(ErrorMessage), { name: "portNo" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, !_unref(isVyzorEmail)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode(_unref(Field), {
                  type: "text",
                  name: "url",
                  autocomplete: "off",
                  modelValue: url.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((url).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_unref(ErrorMessage), { name: "url" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _unref(isVyzorEmail)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode(_unref(Field), {
                  type: "text",
                  name: "apiKey",
                  autocomplete: "off",
                  modelValue: apiKey.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((apiKey).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_unref(ErrorMessage), { name: "apiKey" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _unref(isVyzorEmail)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode(_unref(Field), {
                  type: "text",
                  name: "secret",
                  autocomplete: "off",
                  modelValue: secret.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((secret).value = $event)),
                  class: "form-control"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_unref(ErrorMessage), { name: "secret" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _unref(isVyzorEmail)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_unref(Field), {
                    name: "enableSsl",
                    type: "checkbox",
                    value: true,
                    class: "form-check-input",
                    modelValue: enableSsl.value,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((enableSsl).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_unref(ErrorMessage), { name: "enableSsl" })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, !_unref(isVyzorEmail)]
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode(_unref(Field), {
                  name: "status",
                  modelValue: status.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((status).value = $event)),
                  class: "form-select form-select-lg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: status.value,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((status).value = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_unref(ErrorMessage), { name: "status" })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "showDialog"])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}
}

})